import { useEffect } from "react";
import { Link, useRouteError, isRouteErrorResponse } from "react-router-dom";

export function ErrorPage() {
    const error = useRouteError();

    useEffect(() => {
        if (error) {
            console.error("App error:", error);
        }
    }, [error]);

    const message = isRouteErrorResponse(error)
        ? error.statusText
        : error instanceof Error
          ? error.message
          : "Unknown error";

    return (
        <div className="min-h-screen bg-white flex items-center justify-center px-4">
            <div className="text-center max-w-md">
                <h1 className="text-3xl font-eb-garamond font-light text-gray-900 mb-3">
                    Something went wrong
                </h1>
                <p className="text-[0.9375rem] text-gray-500 leading-relaxed mb-2">
                    We encountered an unexpected error. This has been logged and
                    our team will look into it.
                </p>
                {import.meta.env.DEV && (
                    <p className="text-xs text-gray-400 mb-8">{message}</p>
                )}
                {!import.meta.env.DEV && <div className="mb-8" />}

                <Link
                    to="/assistant"
                    className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium text-white bg-gray-900 hover:bg-gray-700 transition-colors"
                >
                    Home
                </Link>
            </div>
        </div>
    );
}
